/**
 * 작성자 : 한영광
 * 날짜 : 2024.09.12
 * 기능 : 방송장비 설정 복사 진행도 모달
 */

import styled from 'styled-components';
import { IModal } from 'customTypes';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5010;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 60%);
  backdrop-filter: blur(0.5rem);
  user-select: none;
  .modal {
    width: 25rem;
    max-width: calc(100vw - 2rem);
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    max-height: calc(100vh - 2rem);
    .body {
      background-color: #34ab59;
      color: #ffffff;
      padding: 1rem 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      overflow: auto;
      max-height: 19.75rem;
      @media (min-width: 768px) {
        max-height: 28.75rem;
      }
      @media (min-width: 1025px) {
        max-height: 42.75rem;
      }
      .cardContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
`;

const ProgressModal = ({ openModal, setOpenModal, copyState, loading }: any) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!loading) {
      onClickClose();
    }
  }, [loading]);

  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };
  return (
    <Root>
      <div className='modal'>
        <div className='body'>
          <div className='cardContainer'>{`${t('진행')} : ${copyState.currentCount} / ${copyState.totalCount}`}</div>
          <div className='cardContainer'>{`${t('진행 중인 방송 장비 명')} : ${copyState.bsName}`}</div>
          <div className='cardContainer'>{`${t('진행 내용')} : ${copyState.currentContent}`}</div>
        </div>
      </div>
    </Root>
  );
};

export default ProgressModal;
